/* Onboarding novo (leads do fluxo novo) -- backend /onboarding */
import { apiFetch } from './apiClient';
import { uploadArquivoGenerico } from './arquivos';

export const buscarOnboarding = (leadId) => apiFetch(`/onboarding/${leadId}`);
export const salvarItemOnboarding = (leadId, chave, corpo) =>
  apiFetch(`/onboarding/${leadId}/itens/${encodeURIComponent(chave)}`, { method: 'PUT', body: JSON.stringify(corpo) });
export const reunioesDoMes = (mes) => apiFetch(`/onboarding/reunioes?mes=${mes}`);

/* sobe o arquivo e devolve { arquivo_path, arquivo_nome } pra gravar no item */
export async function enviarAnexoOnboarding(leadId, file) {
  const up = await uploadArquivoGenerico(file, `onboarding/${leadId}`);
  return { arquivo_path: up.url, arquivo_nome: up.nome };
}

/* pendências de cadastro (aviso ao entrar no sistema) */
export const resumoPendencias = () => apiFetch('/pendencias/resumo');
